import { render } from "./messagePage.vue?vue&type=template&id=24d43ad0&scoped=true&ts=true"
import script from "./messagePage.vue?vue&type=script&lang=ts"
export * from "./messagePage.vue?vue&type=script&lang=ts"

import "./messagePage.vue?vue&type=style&index=0&id=24d43ad0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d43ad0"]])

export default __exports__